var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _g, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferReviewComparisonUtilityHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 210,
    viewBox: "0 0 412 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326.273 84.6895V160.886L206.375 195.521V116.899L326.273 84.6895Z",
    fill: "#B8B2BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.375 116.871V114.275L272.215 66.6523L326.273 82.2368V84.6615L206.375 116.871Z",
    fill: "#673929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.043 197.051L69.8438 145.272V72.1152L199.19 119.472L202.043 117.407V197.051Z",
    fill: "#EADFDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8438 146.862L202.757 198.921V196.948L202.043 197.05L69.8438 145.271V146.862Z",
    fill: "#030511"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.35 147.998L0 114.179L22.5842 108.238V108.984L2.57117 114.261L85.2721 146.651L86.35 147.998Z",
    fill: "#3A4072"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M199.19 119.473L63.4677 69.7817L62.7129 68.0664L198.116 117.639L199.19 119.473Z",
    fill: "#030511"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203.16 116.596L202.755 196.951L202.043 197.053V117.409L203.16 116.596Z",
    fill: "#030511"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M331.433 83.7246L272.215 66.6517L199.189 119.471L198.119 117.635L272.215 64.041L332.743 82.2362L331.433 83.7246Z",
    fill: "#030511"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M326.273 160.856V82.2363L327.893 82.6984V160.388L326.273 160.856Z",
    fill: "#030511"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M272.215 64.0435L135.943 17.3574L62.7129 68.0669L198.12 117.638L272.215 64.0435Z",
    fill: "#131B3E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M203.159 116.594L206.374 114.275V195.493V197.879L202.756 198.922L203.159 116.594Z",
    fill: "#030511"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2174 155.995V99.1438L118.073 107.328V164.162L119.241 164.595V106.481L96.2949 97.6289V155.633L97.2174 155.995Z",
    fill: "#030511"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.283 164.978V106.252L119.242 106.483V164.597L120.283 164.978Z",
    fill: "#030511"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.282 106.253L97.4179 97.4473L96.2949 97.6313L119.241 106.484L120.282 106.253Z",
    fill: "#030511"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3052 99.9643V156.01L97.2168 155.995V99.1445L99.3052 99.9643Z",
    fill: "url(#paint0_linear_1415_3051)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M144.059 154.032V116.82L187.998 133.506V170.814L189.166 171.248V132.66L143.137 115.305V153.67L144.059 154.032Z",
    fill: "#030511"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M190.205 170.901V132.354L189.166 132.585V171.248L190.205 170.901Z",
    fill: "#030511"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M143.137 115.307L144.26 115.123L190.205 132.355L189.166 132.662L143.137 115.307Z",
    fill: "#030511"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M146.145 117.64V151.737L144.057 152.653V116.82L146.145 117.64Z",
    fill: "url(#paint1_linear_1415_3051)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3052 156.01L118.073 163.023V164.163L97.2168 155.996L99.3052 156.01Z",
    fill: "url(#paint2_linear_1415_3051)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M187.996 170.817L144.057 154.034V152.66L187.996 169.445V170.817Z",
    fill: "#030511"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M146.145 151.736L187.996 167.634V169.443L144.057 152.652L146.145 151.736Z",
    fill: "url(#paint3_linear_1415_3051)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M150.653 119.325V151.075L166.027 156.94V125.211L168.755 126.207V157.977L187.22 164.991V133.211L187.997 133.507V167.635L146.146 151.737V117.641L150.653 119.325Z",
    fill: "#20130C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M153.459 120.389V149.966L166.028 154.815V156.939L150.654 151.074V119.324L153.459 120.389Z",
    fill: "#875532"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M168.756 126.207V156.01L187.22 162.994V133.211L168.756 126.207Z",
    fill: "#DFB26F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M168.756 156.012L187.22 162.995V164.993L168.756 157.978V156.012Z",
    fill: "#875532"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M184.543 138.98L172.992 142.386L181.712 145.966L178.767 156.182L180.616 156.822L183.33 150.468L181.078 156.941L181.424 157.078L184.081 150.554L187.219 151.803V148.534L184.889 149.227L185.496 147.236L187.219 147.841V140.107L184.543 138.98Z",
    fill: "#291D1D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M182.162 131.293L183.211 139.375L184.543 138.982L187.219 140.108V133.213L182.162 131.293Z",
    fill: "#7E5B42"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M153.455 130.668V149.967L166.025 154.816V125.211L153.455 120.391V130.668Z",
    fill: "#DFB26F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M168.756 136.498C168.756 136.613 172.994 142.386 172.994 142.386L181.716 145.966L178.771 156.184L171.926 153.499L170.906 156.824L168.756 156.01V136.498Z",
    fill: "#BA7E45"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M178.767 156.181L178.098 159.544L179.245 159.977L180.104 160.302L180.626 160.499L181.943 160.165L181.569 157.307L184.34 158.34L184.543 161.981L185.801 162.457V158.375L187.218 158.029V151.802L184.081 150.553L181.424 157.076L181.078 156.939L183.33 150.467L180.616 156.821L178.767 156.181Z",
    fill: "#BA7E45"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M185.496 147.236L184.889 149.228L187.218 148.535V147.841L185.496 147.236Z",
    fill: "#BA7E45"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M168.756 136.499L179.722 140.403L183.213 139.373L182.164 131.291L168.756 126.207V136.499Z",
    fill: "#C9945A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M153.455 120.391V130.668L166.025 135.403V125.211L153.455 120.391Z",
    fill: "#C9945A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M166.026 144.174L163.982 144.983L166.026 146.136V144.174Z",
    fill: "#BA7E45"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3066 99.9648V156.01L118.074 163.022V107.329L99.3066 99.9648Z",
    fill: "#28202F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M102.242 115.92V153.643L107.209 155.606V117.944L102.242 115.92Z",
    fill: "#20130C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M109.363 106.252V143.975L114.33 145.938V108.276L109.363 106.252Z",
    fill: "#20130C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M104.725 116.932V152.66L107.209 153.758V155.606L102.242 153.643V115.92L104.725 116.932Z",
    fill: "#875532"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M104.727 116.932V152.66L107.21 153.758V117.944L104.727 116.932Z",
    fill: "#C9945A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M107.21 151.422L104.727 152.661L107.21 153.759V151.422Z",
    fill: "#BA7E45"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M109.363 106.252L111.846 107.264V143.278L114.33 144.601V145.938L109.363 143.975V106.252Z",
    fill: "#875532"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M111.844 107.262V123.566L114.327 123.106V108.274L111.844 107.262Z",
    fill: "#BA7E45"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M111.844 137.271L114.327 136.5V123.109L111.844 123.569V137.271Z",
    fill: "#C9945A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M114.327 144.6L111.844 143.277V137.269L114.327 136.498V144.6Z",
    fill: "#BA7E45"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8438 72.1152L90.4581 79.6632V153.356L69.8438 145.272V72.1152Z",
    fill: "#C1865C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8438 117.639V124.994L90.4581 132.998V125.32L69.8438 117.639Z",
    fill: "#875532",
    fillOpacity: 0.6
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8438 82.6035V89.9593L90.4581 97.9631V90.2843L69.8438 82.6035Z",
    fill: "#875532",
    fillOpacity: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M272.215 64.0435L135.943 17.3574L62.7129 68.0669L198.12 117.638L272.215 64.0435Z",
    fill: "url(#paint4_linear_1415_3051)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M233.223 101.543L262.176 93.8457V98.002L233.223 106.084V101.543Z",
    fill: "#190C15"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M272.215 83.8163L301.169 76.1191V80.2754L272.215 88.357V83.8163Z",
    fill: "#190C15"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M248.749 82.1705L266.904 77.3457L267.483 81.3446L239.174 89.2462L248.749 82.1705Z",
    fill: "#190C15"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M206.375 197.879L327.893 162.359V160.389L206.375 195.493V197.879Z",
    fill: "#030511"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M272.215 64.0435L332.743 82.2387L194.671 34.2892L135.943 17.3574L272.215 64.0435Z",
    fill: "#454E79"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M187.316 22.8965V34.9564L199.19 38.021V20.0098L187.316 22.8965Z",
    fill: "#010510"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M187.317 22.8954L176.922 19.2012V31.394L187.317 34.9554V22.8954Z",
    fill: "#02030D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M187.316 22.9987C187.304 22.9987 187.293 22.9987 187.281 22.9926L176.886 19.2983C176.843 19.284 176.816 19.2411 176.818 19.1961C176.821 19.1511 176.853 19.1123 176.898 19.1021L188.95 16.2931C188.95 16.2931 188.967 16.291 188.973 16.291C188.985 16.291 188.995 16.291 189.008 16.2971L199.225 19.9137C199.268 19.928 199.294 19.9709 199.292 20.0159C199.29 20.0609 199.257 20.0997 199.214 20.11L187.34 22.9967C187.34 22.9967 187.324 22.9987 187.316 22.9987Z",
    fill: "#4C4D69"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M188.972 16.3939L199.189 20.0104L187.315 22.8971L176.92 19.2029L188.972 16.3939ZM188.972 16.1895C188.955 16.1895 188.941 16.1895 188.925 16.1956L176.873 19.0046C176.785 19.025 176.719 19.1007 176.715 19.1927C176.711 19.2826 176.766 19.3665 176.85 19.3971L187.245 23.0914C187.268 23.0995 187.29 23.1036 187.313 23.1036C187.329 23.1036 187.345 23.1036 187.362 23.0975L199.236 20.2108C199.324 20.1904 199.387 20.1127 199.391 20.0227C199.395 19.9328 199.34 19.8489 199.256 19.8203L189.039 16.2038C189.017 16.1956 188.994 16.1915 188.972 16.1915V16.1895Z",
    fill: "#141730"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M180.041 19.6465L187.317 22.0119",
    stroke: "#B2B6D1",
    strokeWidth: 1.45465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M189.203 16.7773L198.289 19.9237",
    stroke: "#B2B6D1",
    strokeWidth: 1.45465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M180.588 19.4906L188.645 17.5566L195.835 19.9241L187.635 21.8867L180.588 19.4906Z",
    fill: "#020206"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M272.215 64.0441L202.043 40.0039L287.704 68.7012L272.215 64.0441Z",
    fill: "url(#paint5_linear_1415_3051)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8426 142.07L50.3594 147.275L201.06 207.178L352.61 162.361L327.892 153.182V154.48L349.143 162.459L201.06 206.077L53.266 147.294L69.8426 142.849V142.07Z",
    fill: "#3A4173"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M202.758 198.922L201.062 206.075L349.145 162.458L327.895 154.479V160.389V162.36L202.758 198.922Z",
    fill: "#0D1329"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M327.893 154.48V153.182L352.611 162.361L318.963 172.311L324.911 169.598L349.144 162.459L327.893 154.48Z",
    fill: "url(#paint6_linear_1415_3051)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8422 142.848L53.2656 147.292L201.06 206.075L202.756 198.922L69.8422 145.272V142.848Z",
    fill: "#040719"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1558 155.996L11.4531 178.35L39.0017 191.452L123.355 167.823L93.1558 155.996Z",
    fill: "url(#paint7_linear_1415_3051)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9961 191.451V192.607L110.848 172.066L110.854 171.322L38.9961 191.451Z",
    fill: "url(#paint8_linear_1415_3051)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M110.862 171.324L110.854 172.068L201.485 208.309L352.611 163.457V162.361L201.061 207.179L110.862 171.324Z",
    fill: "#32355F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M86.35 147.998L0 114.179L22.5842 108.238V108.984L2.57117 114.261L85.2721 146.651L86.35 147.998Z",
    fill: "url(#paint9_linear_1415_3051)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5853 108.986L2.57227 114.263L69.8141 140.763L69.905 133.489L22.5853 115.064V108.986Z",
    fill: "#090F1F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 114.18V115.637L69.843 142.848V141.534L0 114.18Z",
    fill: "#42466D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9726 61.4425L18.3359 41.8039V39.3281L74.509 59.8948L71.9726 61.4425Z",
    fill: "#030511"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M74.509 59.8948L18.3359 39.328L77.5673 10.5684L124.843 19.4781L131.389 21.4782L74.509 59.8948Z",
    fill: "#030511"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M120.844 25.8421L100.297 18.3871L77.75 10.5684L124.48 19.2962L131.39 21.66L120.844 25.8421Z",
    fill: "url(#paint10_linear_1415_3051)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M22.584 115.063V43.3613L30.277 46.1765V118.072L22.584 115.063Z",
    fill: "#E7DBD5"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8424 131.101L40.0049 119.434L36.1328 120.362L69.8424 133.544V131.101Z",
    fill: "#283468"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0059 119.52V58.541L64.1282 67.1725L62.7128 68.1518L63.4675 69.867L69.8433 72.2017V131.199L40.0059 119.52Z",
    fill: "#DFCCC5"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0859 64.8633L59.5068 70.5794V76.0625L44.0859 70.3096V64.8633Z",
    fill: "#352D42"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1738 65.6367V69.654L59.5042 74.5605V70.578L46.1738 65.6367Z",
    fill: "#977044"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1756 65.6391L44.9688 65.1914V70.1021L59.506 75.4564V74.563L46.1756 69.6564V65.6391Z",
    fill: "#483B3E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M69.844 74.5617L66.5508 73.3105V78.3909L69.844 79.6789V74.5617Z",
    fill: "#352D42"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M68.543 74.0664V77.9283L69.8439 78.4271V74.5612L68.543 74.0664Z",
    fill: "#8E604C"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2812 73.5859V78.0632L69.8442 79.0629V78.4271L68.5433 77.9283V74.0664L67.2812 73.5859Z",
    fill: "#312832"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1328 57.3398L40.0049 58.5419V119.52L36.1328 120.363V57.3398Z",
    fill: "#B0A0AB"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9725 61.4434L30.2773 46.1758V118.071L36.1336 120.361V57.3382L64.128 67.1718L71.9725 61.4434Z",
    fill: "#DACDCB"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M249.873 137.623L252.164 138.601L262.653 135.816L260.362 135.08L249.873 137.623Z",
    fill: "#1E1E21"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M262.657 135.816L252.168 138.601V157.409L262.657 154.527V135.816Z",
    fill: "url(#paint11_linear_1415_3051)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M249.873 137.623L252.164 138.6V157.409L249.941 156.481L249.873 137.623Z",
    fill: "#17181A"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0219 85.2335V89.9663C26.0219 89.9663 28.2106 84.8655 28.2269 77.0682C28.2433 69.1031 24.7148 71.9653 24.7148 71.9653",
    stroke: "url(#paint12_linear_1415_3051)",
    strokeWidth: 2.90929,
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7129 71.9674V81.6824C24.7129 81.8439 24.8274 81.9809 24.9849 82.0136L27.1716 82.954C27.552 83.0297 27.9079 82.7373 27.9079 82.3489V73.0325C27.9079 72.7402 27.6972 72.4887 27.4109 72.4376L25.2304 71.5871C24.9624 71.538 24.7149 71.6934 24.7149 71.9674H24.7129Z",
    fill: "url(#paint13_linear_1415_3051)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9779 85.6242C25.7713 85.6242 25.6035 85.4749 25.6035 85.2889C25.6035 85.2889 24.9776 83.2383 25.2722 82.6802C25.5667 82.1221 25.7713 82.5208 25.9758 82.5208C26.1824 82.5208 26.8451 82.6046 26.8451 82.7906L26.3501 85.2889C26.3501 85.4729 26.1824 85.6242 25.9758 85.6242H25.9779Z",
    fill: "url(#paint14_linear_1415_3051)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1367 72.257V81.972C24.1367 82.1335 24.2513 82.2705 24.4088 82.3032L26.5954 83.2436C26.9758 83.3192 27.3318 83.0269 27.3318 82.6385V73.3221C27.3318 73.0298 27.1211 72.7783 26.8347 72.7272L24.6542 71.8256C24.3863 71.7765 24.1388 71.983 24.1388 72.257H24.1367Z",
    fill: "url(#paint15_linear_1415_3051)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1367 72.257V80.0748C24.1367 80.2363 24.2513 80.3733 24.4088 80.406L26.5954 81.3464C26.9758 81.422 27.3318 81.1297 27.3318 80.7413V73.3221C27.3318 73.0298 27.1211 72.7783 26.8347 72.7272L24.6542 71.8256C24.3863 71.7765 24.1388 71.983 24.1388 72.257H24.1367Z",
    fill: "url(#paint16_linear_1415_3051)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4082 82.3008C24.4082 84.1694 27.1287 90.6849 27.908 82.3478",
    stroke: "url(#paint17_linear_1415_3051)",
    strokeWidth: 2.90929,
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M256.713 156.215V208.582H383.769V185.686",
    stroke: "url(#paint18_linear_1415_3051)",
    strokeWidth: 0.727323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M256.713 156.332V208.582H383.662V185.686",
    stroke: "url(#paint19_linear_1415_3051)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-offer-review-house-labels": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.195 5.74447V20H366.507V9.512C366.263 9.87858 365.428 10.0619 364.817 10.0619H363.717V7.74024H364.715C365.835 7.74024 366.466 7.29221 366.65 5.74447H369.195ZM376.412 20.1629C372.868 20.1629 371.239 17.7191 371.239 13.361V12.3835C371.239 8.02536 372.868 5.58155 376.412 5.58155H377.206C380.77 5.58155 382.379 8.02536 382.379 12.3835V13.361C382.379 17.7191 380.77 20.1629 377.206 20.1629H376.412ZM373.927 14.0738C373.927 16.5787 374.925 17.8209 376.534 17.8209H377.104C378.713 17.8209 379.69 16.5787 379.69 14.0738V11.6707C379.69 9.14543 378.713 7.90317 377.104 7.90317H376.534C374.925 7.90317 373.927 9.14543 373.927 11.6707V14.0738ZM389.11 20.1629C385.567 20.1629 383.938 17.7191 383.938 13.361V12.3835C383.938 8.02536 385.567 5.58155 389.11 5.58155H389.905C393.468 5.58155 395.077 8.02536 395.077 12.3835V13.361C395.077 17.7191 393.468 20.1629 389.905 20.1629H389.11ZM386.626 14.0738C386.626 16.5787 387.624 17.8209 389.233 17.8209H389.803C391.412 17.8209 392.389 16.5787 392.389 14.0738V11.6707C392.389 9.14543 391.412 7.90317 389.803 7.90317H389.233C387.624 7.90317 386.626 9.14543 386.626 11.6707V14.0738ZM396.555 20L406.9 5.74447H409.12L398.775 20H396.555ZM396.188 8.83996C396.188 7.0071 397.471 5.58155 399.304 5.58155C401.137 5.58155 402.4 7.0071 402.4 8.83996C402.4 10.6728 401.137 12.0984 399.304 12.0984C397.471 12.0984 396.188 10.6728 396.188 8.83996ZM397.96 8.83996C397.96 9.77675 398.49 10.4692 399.304 10.4692C400.119 10.4692 400.669 9.77675 400.669 8.83996C400.669 7.90317 400.119 7.21075 399.304 7.21075C398.49 7.21075 397.96 7.90317 397.96 8.83996ZM403.275 16.9045C403.275 15.0717 404.558 13.6461 406.391 13.6461C408.224 13.6461 409.487 15.0717 409.487 16.9045C409.487 18.7374 408.224 20.1629 406.391 20.1629C404.558 20.1629 403.275 18.7374 403.275 16.9045ZM405.047 16.9045C405.047 17.8413 405.577 18.5337 406.391 18.5337C407.206 18.5337 407.756 17.8413 407.756 16.9045C407.756 15.9677 407.206 15.2753 406.391 15.2753C405.577 15.2753 405.047 15.9677 405.047 16.9045Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.22 27.4594V36.9902H370.913V35.5152C370.384 36.5553 369.306 37.1415 367.944 37.1415C365.788 37.1415 364.389 35.5909 364.389 33.3594V27.4594H366.715V32.8678C366.715 34.1726 367.509 35.0803 368.701 35.0803C370.005 35.0803 370.913 34.0591 370.913 32.6598V27.4594H373.22ZM376.112 24.585H378.438V27.4594H381.086V29.4072H378.438V33.5675C378.438 34.5319 378.949 35.0236 379.819 35.0236H381.086V36.9902H379.554C377.474 36.9902 376.112 35.78 376.112 33.662V29.4072H374.24V27.4594H376.112V24.585ZM382.361 36.9902V27.4594H384.687V36.9902H382.361ZM382.285 25.9655V23.3747H384.782V25.9655H382.285ZM386.655 36.9902V23.3747H388.981V36.9902H386.655ZM390.949 36.9902V27.4594H393.275V36.9902H390.949ZM390.873 25.9655V23.3747H393.37V25.9655H390.873ZM396.151 24.585H398.477V27.4594H401.124V29.4072H398.477V33.5675C398.477 34.5319 398.987 35.0236 399.857 35.0236H401.124V36.9902H399.592C397.512 36.9902 396.151 35.78 396.151 33.662V29.4072H394.279V27.4594H396.151V24.585ZM403.516 40.848L404.878 36.9713L401.398 27.4594H403.762L405.955 34.0024L408.149 27.4594H410.532L407.62 35.4396L405.729 40.848H403.516Z",
    fill: "black"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M378.977 181.77L383.489 183.324V54.8177L378.977 53.2637V181.77Z",
    fill: "url(#paint20_linear_1415_3051)",
    stroke: "#0B0B18",
    strokeWidth: 0.418393,
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M383.49 183.326L388.122 182.071V53.5645L383.49 54.8196V183.326Z",
    fill: "url(#paint21_linear_1415_3051)",
    stroke: "#0B0B18",
    strokeWidth: 0.418393,
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M378.977 53.2649L383.489 54.819L388.121 53.5638L383.609 52.0098L378.977 53.2649Z",
    fill: "#D9AA76",
    stroke: "#0B0B18",
    strokeWidth: 0.418393,
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M378.408 53.2345L383.489 54.9977V53.8023L378.408 52.0391V53.2345Z",
    fill: "#2A2336",
    stroke: "#0B0B18",
    strokeWidth: 0.358623,
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M383.49 54.9984L388.69 53.5938V52.3984L383.49 53.803V54.9984Z",
    fill: "#1A1628",
    stroke: "#0B0B18",
    strokeWidth: 0.358623,
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M378.408 52.0394L383.489 53.8026L388.689 52.398L383.608 50.6348L378.408 52.0394Z",
    fill: "#3A2F3A",
    stroke: "#0B0B18",
    strokeWidth: 0.358623,
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M379.965 171.641V70.9277",
    stroke: "#8D5F3B",
    strokeWidth: 0.268967
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M381.1 174.719V74.9023",
    stroke: "#8D5F3B",
    strokeWidth: 0.268967
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M382.234 167.934V66.0254",
    stroke: "#8D5F3B",
    strokeWidth: 0.268967
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M378.977 181.772L383.489 183.326V175.556L378.977 174.002V181.772Z",
    fill: "#7A5233",
    stroke: "#0B0B18",
    strokeWidth: 0.418393,
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M383.49 183.326L388.122 182.071V174.301L383.49 175.556V183.326Z",
    fill: "#4C3120",
    stroke: "#0B0B18",
    strokeWidth: 0.418393,
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M384.953 147.074L386.926 147.762",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M386.688 138.826L387.936 139.254",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M384.953 131.535L386.926 132.223",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M386.688 123.287L387.951 123.738",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M384.953 115.994L386.926 116.681",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M386.688 107.746L387.967 108.238",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M384.953 100.453L386.926 101.14",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M386.688 92.2051L388.003 92.5575",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M384.953 84.9141L386.926 85.6014",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M386.688 76.6641L387.967 77.0664",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M379.545 137.483L381.786 138.26V132.881L379.545 132.104V137.483Z",
    fill: "#ECEAEE",
    stroke: "#0B0B18",
    strokeWidth: 0.328737,
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M381.785 138.259L382.383 138.11V132.73L381.785 132.88V138.259Z",
    fill: "#9C98A4",
    stroke: "#0B0B18",
    strokeWidth: 0.328737,
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M379.545 132.103L381.786 132.88L382.384 132.73L380.113 131.953L379.545 132.103Z",
    fill: "white",
    stroke: "#0B0B18",
    strokeWidth: 0.328737,
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M381.249 71.3755L368.488 58.2559",
    stroke: "#262842",
    strokeWidth: 0.597705,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M381.25 71.375L392.248 66.4141",
    stroke: "#262842",
    strokeWidth: 0.597705,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M354.322 54.76L401.81 71.1371V67.8498L354.322 51.4727V54.76Z",
    fill: "url(#paint22_linear_1415_3051)",
    stroke: "#0B0B18",
    strokeWidth: 0.418393,
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M401.809 71.1339L404.976 70.2971V67.0098L401.809 67.8465V71.1339Z",
    fill: "#6E4A2E",
    stroke: "#0B0B18",
    strokeWidth: 0.418393,
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M354.322 51.4715L401.81 67.8486L404.978 67.0119L357.49 50.6348L354.322 51.4715Z",
    fill: "#DCAE7C",
    stroke: "#0B0B18",
    strokeWidth: 0.418393,
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M361.734 50.9941H360.539V52.7873H361.734V50.9941Z",
    fill: "#2A2C48",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M363.076 50.0957H359.191V50.9923H363.076V50.0957Z",
    fill: "url(#paint23_linear_1415_3051)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M361.134 50.7259C362.207 50.7259 363.076 50.4449 363.076 50.0983C363.076 49.7517 362.207 49.4707 361.134 49.4707C360.061 49.4707 359.191 49.7517 359.191 50.0983C359.191 50.4449 360.061 50.7259 361.134 50.7259Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M362.78 48.9023H359.492V49.7989H362.78V48.9023Z",
    fill: "url(#paint24_linear_1415_3051)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M361.136 49.4392C362.044 49.4392 362.78 49.1983 362.78 48.9012C362.78 48.6041 362.044 48.3633 361.136 48.3633C360.228 48.3633 359.492 48.6041 359.492 48.9012C359.492 49.1983 360.228 49.4392 361.136 49.4392Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M362.481 47.707H359.791V48.6036H362.481V47.707Z",
    fill: "url(#paint25_linear_1415_3051)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M361.136 48.1239C361.879 48.1239 362.481 47.9366 362.481 47.7055C362.481 47.4744 361.879 47.2871 361.136 47.2871C360.393 47.2871 359.791 47.4744 359.791 47.7055C359.791 47.9366 360.393 48.1239 361.136 48.1239Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M371.924 54.4902H370.729V56.2833H371.924V54.4902Z",
    fill: "#2A2C48",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M373.27 53.5938H369.385V54.4903H373.27V53.5938Z",
    fill: "url(#paint26_linear_1415_3051)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M371.327 54.222C372.4 54.222 373.27 53.941 373.27 53.5944C373.27 53.2478 372.4 52.9668 371.327 52.9668C370.254 52.9668 369.385 53.2478 369.385 53.5944C369.385 53.941 370.254 54.222 371.327 54.222Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M372.969 52.3984H369.682V53.295H372.969V52.3984Z",
    fill: "url(#paint27_linear_1415_3051)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M371.325 52.9372C372.233 52.9372 372.969 52.6964 372.969 52.3993C372.969 52.1022 372.233 51.8613 371.325 51.8613C370.418 51.8613 369.682 52.1022 369.682 52.3993C369.682 52.6964 370.418 52.9372 371.325 52.9372Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M372.672 51.2031H369.982V52.0997H372.672V51.2031Z",
    fill: "url(#paint28_linear_1415_3051)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M371.327 51.6219C372.07 51.6219 372.672 51.4346 372.672 51.2035C372.672 50.9725 372.07 50.7852 371.327 50.7852C370.585 50.7852 369.982 50.9725 369.982 51.2035C369.982 51.4346 370.585 51.6219 371.327 51.6219Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M399.061 63.8438H397.865V65.6369H399.061V63.8438Z",
    fill: "#2A2C48",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M400.407 62.9473H396.521V63.8438H400.407V62.9473Z",
    fill: "url(#paint29_linear_1415_3051)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M398.464 63.5755C399.537 63.5755 400.407 63.2945 400.407 62.9479C400.407 62.6013 399.537 62.3203 398.464 62.3203C397.391 62.3203 396.521 62.6013 396.521 62.9479C396.521 63.2945 397.391 63.5755 398.464 63.5755Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M400.106 61.752H396.818V62.6485H400.106V61.752Z",
    fill: "url(#paint30_linear_1415_3051)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M398.462 62.2907C399.37 62.2907 400.106 62.0499 400.106 61.7528C400.106 61.4557 399.37 61.2148 398.462 61.2148C397.554 61.2148 396.818 61.4557 396.818 61.7528C396.818 62.0499 397.554 62.2907 398.462 62.2907Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M399.809 60.5566H397.119V61.4532H399.809V60.5566Z",
    fill: "url(#paint31_linear_1415_3051)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M398.464 60.9755C399.207 60.9755 399.809 60.7881 399.809 60.5571C399.809 60.326 399.207 60.1387 398.464 60.1387C397.721 60.1387 397.119 60.326 397.119 60.5571C397.119 60.7881 397.721 60.9755 398.464 60.9755Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M375.213 96.03L378.022 96.9863V88.0208L375.213 87.0645V96.03Z",
    fill: "#23253F",
    stroke: "#0B0B18",
    strokeWidth: 0.328737,
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M378.021 96.9877L382.654 95.7624V86.7969L378.021 88.0222V96.9877Z",
    fill: "#15172C",
    stroke: "#0B0B18",
    strokeWidth: 0.328737,
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M375.213 87.0638L378.022 88.0201L382.654 86.7948L379.815 85.8086L375.213 87.0638Z",
    fill: "#3A3C5C",
    stroke: "#0B0B18",
    strokeWidth: 0.328737,
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M368.039 83.3887V103.113C368.039 103.628 368.7 104.122 369.877 104.487C371.054 104.851 372.65 105.055 374.315 105.055C375.979 105.055 377.576 104.851 378.753 104.487C379.93 104.122 380.591 103.628 380.591 103.113V83.3887H368.039Z",
    fill: "url(#paint32_linear_1415_3051)",
    stroke: "#0B0B18",
    strokeWidth: 0.418393
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M368.039 99.2305C368.039 99.7457 368.7 100.24 369.877 100.604C371.054 100.968 372.65 101.173 374.315 101.173C375.979 101.173 377.576 100.968 378.753 100.604C379.93 100.24 380.591 99.7457 380.591 99.2305",
    stroke: "#8D8996",
    strokeWidth: 0.358623
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M368.039 87.2754C368.039 87.7906 368.7 88.2847 369.877 88.649C371.054 89.0133 372.65 89.2179 374.315 89.2179C375.979 89.2179 377.576 89.0133 378.753 88.649C379.93 88.2847 380.591 87.7906 380.591 87.2754",
    stroke: "#8D8996",
    strokeWidth: 0.358623
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M374.318 85.5722C378.032 85.5722 381.042 84.5955 381.042 83.3906C381.042 82.1857 378.032 81.209 374.318 81.209C370.604 81.209 367.594 82.1857 367.594 83.3906C367.594 84.5955 370.604 85.5722 374.318 85.5722Z",
    fill: "url(#paint33_linear_1415_3051)",
    stroke: "#0B0B18",
    strokeWidth: 0.418393
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M374.317 83.7791C376.793 83.7791 378.8 83.2038 378.8 82.494C378.8 81.7843 376.793 81.209 374.317 81.209C371.841 81.209 369.834 81.7843 369.834 82.494C369.834 83.2038 371.841 83.7791 374.317 83.7791Z",
    fill: "#241C34",
    stroke: "#0B0B18",
    strokeWidth: 0.298852
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M373.717 87.5742H371.027C370.862 87.5742 370.729 87.708 370.729 87.8731V89.6662C370.729 89.8312 370.862 89.965 371.027 89.965H373.717C373.882 89.965 374.016 89.8312 374.016 89.6662V87.8731C374.016 87.708 373.882 87.5742 373.717 87.5742Z",
    fill: "#E2B25E",
    stroke: "#0B0B18",
    strokeWidth: 0.268967
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M372.223 80.0723H370.729V82.7619H372.223V80.0723Z",
    fill: "url(#paint34_linear_1415_3051)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M377.902 81.3262H376.408V84.0158H377.902V81.3262Z",
    fill: "url(#paint35_linear_1415_3051)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M371.477 80.07C370.68 71.6424 370.631 63.2147 371.328 54.7871",
    stroke: "#14162E",
    strokeWidth: 0.448278
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M377.156 81.3266C380.742 77.581 387.845 71.853 398.464 64.1426",
    stroke: "#14162E",
    strokeWidth: 0.448278
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1415_3051",
    x1: 97.2168,
    y1: 127.576,
    x2: 104.253,
    y2: 127.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20130C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1415_3051",
    x1: 143.517,
    y1: 134.735,
    x2: 149.512,
    y2: 134.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20130C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1415_3051",
    x1: -9.16665,
    y1: 160.079,
    x2: 118.073,
    y2: 160.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20130C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1415_3051",
    x1: 144.057,
    y1: 160.589,
    x2: 187.996,
    y2: 160.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20130C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1415_3051",
    x1: 62.7129,
    y1: 67.4965,
    x2: 272.215,
    y2: 67.4965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.139779,
    stopColor: "#39252D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962564,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1415_3051",
    x1: 230.248,
    y1: 51.6897,
    x2: 314.519,
    y2: 67.0445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B6D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2B6D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1415_3051",
    x1: 319.609,
    y1: 165.009,
    x2: 332.339,
    y2: 160.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8BCDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B8BCDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1415_3051",
    x1: 37.4482,
    y1: 219.372,
    x2: 83.487,
    y2: 131.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B8BCDF",
    stopOpacity: 0.721569
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#B8B2BA",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739173,
    stopColor: "#B8B2BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1415_3051",
    x1: 39.9425,
    y1: 192.607,
    x2: 109.901,
    y2: 171.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0224732,
    stopColor: "#2B2D4F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551818,
    stopColor: "#2B2D4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2D4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1415_3051",
    x1: 14.2222,
    y1: 112.599,
    x2: 31.6668,
    y2: 120.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8CB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#8486AE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1415_3051",
    x1: 18.3368,
    y1: 37.668,
    x2: 134.506,
    y2: 37.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63709D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63709D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1415_3051",
    x1: 253.199,
    y1: 145.711,
    x2: 261.798,
    y2: 147.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1415_3051",
    x1: 24.5839,
    y1: 80.7154,
    x2: 28.4294,
    y2: 80.7154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30313A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232429"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1415_3051",
    x1: 24.7129,
    y1: 77.2706,
    x2: 27.9079,
    y2: 77.2706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30313A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232429"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1415_3051",
    x1: 25.1944,
    y1: 84.005,
    x2: 26.8451,
    y2: 84.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#30313A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232429"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1415_3051",
    x1: 24.1367,
    y1: 77.5356,
    x2: 27.3318,
    y2: 77.5356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#30313A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232429"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1415_3051",
    x1: 24.1367,
    y1: 76.587,
    x2: 27.3318,
    y2: 76.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1415_3051",
    x1: 24.2037,
    y1: 84.4985,
    x2: 28.1126,
    y2: 84.4985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30313A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232429"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1415_3051",
    x1: 269.181,
    y1: 177.973,
    x2: 296.218,
    y2: 245.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1415_3051",
    x1: 389.544,
    y1: 182.398,
    x2: 272.341,
    y2: 201.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F2647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8C66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1415_3051",
    x1: 378.977,
    y1: 53.2637,
    x2: 383.489,
    y2: 53.2637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8935F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9744A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1415_3051",
    x1: 383.49,
    y1: 53.5645,
    x2: 388.122,
    y2: 53.5645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E5434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3D26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1415_3051",
    x1: 354.322,
    y1: 51.4727,
    x2: 401.81,
    y2: 51.4727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8935F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9744A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1415_3051",
    x1: 359.191,
    y1: 50.0957,
    x2: 363.076,
    y2: 50.0957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1415_3051",
    x1: 359.492,
    y1: 48.9023,
    x2: 362.78,
    y2: 48.9023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1415_3051",
    x1: 359.791,
    y1: 47.707,
    x2: 362.481,
    y2: 47.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1415_3051",
    x1: 369.385,
    y1: 53.5938,
    x2: 373.27,
    y2: 53.5938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1415_3051",
    x1: 369.682,
    y1: 52.3984,
    x2: 372.969,
    y2: 52.3984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1415_3051",
    x1: 369.982,
    y1: 51.2031,
    x2: 372.672,
    y2: 51.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1415_3051",
    x1: 396.521,
    y1: 62.9473,
    x2: 400.407,
    y2: 62.9473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1415_3051",
    x1: 396.818,
    y1: 61.752,
    x2: 400.106,
    y2: 61.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1415_3051",
    x1: 397.119,
    y1: 60.5566,
    x2: 399.809,
    y2: 60.5566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1415_3051",
    x1: 368.039,
    y1: 83.3887,
    x2: 380.591,
    y2: 83.3887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECE6E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D6D0D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A09CA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1415_3051",
    x1: 367.594,
    y1: 81.209,
    x2: 381.042,
    y2: 81.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1C1830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171D45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1415_3051",
    x1: 370.729,
    y1: 80.0723,
    x2: 372.223,
    y2: 80.0723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1415_3051",
    x1: 376.408,
    y1: 81.3262,
    x2: 377.902,
    y2: 81.3262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferReviewComparisonUtilityHouse);
export default __webpack_public_path__ + "static/media/offer-review-comparison-utility-house.7391247c6e00c8dc1d7a114759d599ba.svg";
export { ForwardRef as ReactComponent };